// A research source's PDF and a research figure's image (migration 0095), both
// ops.documents rows read through the work API's file download
// (GET /api/work/files/:id), which needs the session, so each is fetched first.
import { Button, Text } from '@olytic/foundation';
import { useEffect, useState } from 'react';

import { authenticatedFetch } from '../auth/authClient';
import { fetchFileUrl, openFile } from '../work/workApi';

/** Opens a source's file in a new tab: the record header's Open PDF. */
export function OpenDocumentButton({ id, name }: { id: string; name: string }) {
  const [error, setError] = useState<string | null>(null);
  const [opening, setOpening] = useState(false);
  const open = () => {
    setError(null);
    setOpening(true);
    openFile(authenticatedFetch, { id, name })
      .catch((e: unknown) => setError(e instanceof Error ? e.message : 'Could not open the file.'))
      .finally(() => setOpening(false));
  };
  return (
    <>
      <Button variant="neutral" loading={opening} onClick={open}>
        Open PDF
      </Button>
      {error ? <Text size="sm" tone="muted">{error}</Text> : null}
    </>
  );
}

/** A figure's image at the width of its field, once fetched. */
export function FigureImage({ id, alt }: { id: string; alt: string }) {
  const [state, setState] = useState<{ id: string; url: string | null } | null>(null);
  useEffect(() => {
    let live = true;
    let url: string | null = null;
    void fetchFileUrl(authenticatedFetch, id).catch(() => null).then((u) => {
      url = u;
      if (live) setState({ id, url: u });
      else if (u) URL.revokeObjectURL(u);
    });
    return () => {
      live = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [id]);
  if (state?.id !== id) return <Text size="sm" tone="muted">Loading the image…</Text>;
  if (!state.url) return <Text size="sm" tone="muted">The image could not be loaded.</Text>;
  return <img src={state.url} alt={alt} className="max-w-full h-auto" />;
}
